import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParseAutocompleteValuePipe } from './_pipes/parse-autocomplete-value.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [ParseAutocompleteValuePipe],
  exports: [ParseAutocompleteValuePipe]
})
export class SharedAutocompleteShellModule {}
